import React from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { createPortal } from 'react-dom';
import { Grid, Menu } from 'semantic-ui-react';
import { uniqueKey } from '../common/keys';
import { getListStyle } from '../viewSettings/sorting/sortHelpers';
import { dragDropperTypes } from './DragDropper';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import SortableGrid from 'SortableGrid';

export const DropGroupWrapper = (props) => {

  const { dgwProps } = props

  const {
    allowSort,
    dndType,
    header,
    showHeader,
    sortFixedCount,
    uks,
  } = dgwProps


  let cn = 'drop-group-container ' + dndType
  let cnc = 'drop-group-content'

  if (!allowSort) { cnc += ' nd' }
  if (sortFixedCount) { cn += ' fixed' }


  const groupContent = () => {
    switch (dndType) {
      case dragDropperTypes.settingsGroups:
        return <React.Fragment >
          {showHeader && header}
          <div key={uks.uk2} className={cnc}>{<DroppableWrapper dgwProps={dgwProps} />}</div>
        </React.Fragment>

      default:
        return <React.Fragment>
          {showHeader && header}
          <div key={uks.uk2} className={cnc}>{<DroppableWrapper dgwProps={dgwProps} />}</div>
        </React.Fragment>
    }
  }

  return <div key={uks.uki} className={cn}>
    {groupContent()}
  </div>
}

export const DroppableWrapper = (props) => {

  const { dgwProps } = props

  const handleUpdateArray = (res) => dgwProps.handleSorted_dataItems(res)

  const {
    allowSort,
    dndType,
    group,
    groupKey,
    horizontal,
    wrapperCns,
  } = dgwProps


  const { elements, dataItems } = group ?? {}

  let cn = 'drop-list ddw active drag zzz'
  if (wrapperCns) { cn += ' ' + wrapperCns }

  return <ItemMenuSquares
    menuItems={dataItems}
    imsType={_imsTypes.sortSelect}
  />
} 